export const visit = (vm, at) => {
vm(require("./features/forms/en.lyaml"));
vm(require("./features/pipelines/en.lyaml"));
at({ "en": { "crm_data": { "no-op": "no-op" } } });
};